import LocationList from './LocationList'
import { useRef, useEffect } from 'react'
import { useAppState, useAppDispatch } from './Context'

function Sidebar({ breadcrumbs, headline, content }) {
  const contentRef = useRef()
  const dispatch = useAppDispatch()
  const { sidebarOpen, mapVisible } = useAppState()

  const handleResize = () => {
    if (contentRef.current) {
      document.getElementById('app').style.setProperty('--map-top-offset', `${contentRef.current.offsetHeight}px`)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleSidebarToggle = () => {
    dispatch({ type: 'setSidebarOpen', payload: !sidebarOpen })
  }

  const handleMapToggle = () => {
    dispatch({ type: 'setMapVisible', payload: !mapVisible })
  }

  return (
    <aside className={`locations-sidebar ${sidebarOpen ? 'locations-sidebar--opened' : 'locations-sidebar--closed'}`}>
      <div ref={contentRef} className="relative py-6 px-4 lg:py-12 lg:px-8 xl:py-16 xl:px-12 2xl:px-24">
        <div className="mb-4 text-sm" dangerouslySetInnerHTML={{ __html: breadcrumbs }} />
        <h1
          className="text-2xl xl:text-3xl 2xl:text-4xl em-bold text-green"
          dangerouslySetInnerHTML={{ __html: headline }}
        />
        <div className="text-base richtext wysiwyg no-last-margin" dangerouslySetInnerHTML={{ __html: content }} />

        <button
          type="button"
          aria-label="Toggle sidebar"
          className="hidden absolute top-1/2 left-full z-10 w-7 h-16 bg-white transition-all -translate-y-8 md:flex hover:text-white hover:bg-green"
          onClick={handleSidebarToggle}
        >
          <span className="sr-only">Toggle sidebar</span>
          <svg viewBox="0 0 9 18" fill="none" className={`m-auto w-2 ${sidebarOpen ? '' : '-scale-x-100'} `}>
            <path
              d="M8.8.176c.16.12.2.282.2.442 0 .161-.04.322-.16.443L1.543 8.98 8.8 16.94a.6.6 0 0 1-.04.884.595.595 0 0 1-.882-.04L.18 9.422a.584.584 0 0 1 0-.844L7.878.216c.28-.281.681-.281.922-.04Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <button
        type="button"
        aria-label="Toggle map"
        className="z-20 py-2 px-4 w-full text-sm font-semibold text-center text-white transition-all md:hidden hover:bg-opacity-90 bg-green"
        onClick={handleMapToggle}
      >
        <span className="sr-only">Toggle map</span>
        <span>{mapVisible ? 'Hide Map' : 'Show Map'}</span>
      </button>

      <LocationList />
    </aside>
  )
}

export default Sidebar
